import { useToggle } from "usehooks-ts";

import { SKSpinner } from "components/customElements/skSpinner";

export const TOOL_PRECIOUS_METALS_NAME = "Precious Metals";
export const TOOL_PRECIOUS_METALS_DESCRIPTION =
  "Comprehensive analysis of the global precious metals complex.";

const ToolPreciousMetal = () => {
  const [isLoading, toggleIsLoading] = useToggle(true);
  return (
    <div className="">
      {isLoading && (
        <div className="w-full flex justify-center">
          <SKSpinner />
        </div>
      )}
      <iframe
        src="https://camerondesign-golds-953910356470.asia-northeast1.run.app?theme=smartkarma"
        onLoad={toggleIsLoading}
        onError={toggleIsLoading}
        frameBorder={0}
        className="w-full h-[600px] md:h-[215vh] overflow-hidden border-0"
        allowFullScreen
        allow="clipboard-write"
      ></iframe>
    </div>
  );
};

export default ToolPreciousMetal;
